<template>
  <div class="modalBackground">
    <div class="ViewMultiMessage">
      <div class="multiMessageContent">
        <div class="multiMessageSubject" v-if="renderSubject">
          <h3>SUBJECT</h3>
          <div v-html="renderSubject"></div>
        </div>
        <div class="multiMessageTemplate">
          <h3>TEMPLATE</h3>
          <div v-html="renderContent"></div>
        </div>
      </div>
      <button-global
        type="negative"
        text="CLOSE"
        size="large"
        @eventPassed="$emit('closeContentModal')"
      ></button-global>
    </div>
  </div>
</template>

<script>
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";

export default {
  name: "ViewMultiMessage",
  components: {
    ButtonGlobal,
  },
  props: {
    renderContent: {
      type: String,
      default: "None",
    },
    renderSubject: {
      type: [String, Boolean],
      default: null,
    },
  },
};
</script>

<style scoped>
h3 {
  color: #707070;
  font-weight: bold;
}
.modalBackground {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 1005;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ViewMultiMessage {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  width: 55vw;
  min-height: 55vh;
  max-height: 95vh;
  border-radius: 5px;
  padding: 24px 32px;
}
.multiMessageContent {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
}
.multiMessageSubject,
.multiMessageTemplate {
  display: flex;
  flex-direction: column;
}

.multiMessageSubject {
  margin-top: 20px;
}
.multiMessageTemplate {
  margin-bottom: 30px;
}

.multiMessageContent h3 {
  margin-bottom: 16px;
}
</style>
